import { render, staticRenderFns } from "./truckUtilitationReport.vue?vue&type=template&id=5bf481a0&scoped=true"
import script from "./truckUtilitationReport.vue?vue&type=script&lang=js"
export * from "./truckUtilitationReport.vue?vue&type=script&lang=js"
import style0 from "./truckUtilitationReport.vue?vue&type=style&index=0&id=5bf481a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf481a0",
  null
  
)

export default component.exports